<template>
  <dialogTemplate
    :openDialog="isOpen"
    :widthDialog="'95%'"
    :classDialog="'dialogTransferHandling dialog-cxl-vbden'"
    :offsetTop="'8vh'"
    :appendToBody="true"
    :modalAppendToBody="true"
    @closeDialog="$emit('closeDialog')"
    @closed="$emit('closed')"
  >
    <template #body>
      <div class="title flex-row">
        <h2 class="dialogTitle">Chuyển xử lý văn bản đến</h2>
        &nbsp;&nbsp;
        <div class="title-content">
          <el-tag class="priority lv3">
            {{ quote }}
          </el-tag>
        </div>
      </div>
      <!-- body -->

      <el-row class="dialog-body margin-0" :gutter="24">
        <el-col :span="12" class="list-collapse__transfer">
          <h4 class="margin-bottom-10">Danh sách chuyển xử lý</h4>
          <div class="flex-row flex__left margin-bottom-10">
            <el-input
              prefix-icon="el-icon-search"
              size="medium"
              placeholder="Tìm kiếm theo tên/emai/đơn vị/chức vụ"
              @keydown.enter.exact.native="searchTree"
              v-model="query"
            ></el-input>
          </div>
          <hashtag-common
            :stepId="stepId"
            @selectTags="
              (event) =>
                selectTags(event, defaultProcessType || PROCESS_TYPE.PHOIHOP)
            "
          />
          <VuePerfectScrollbar class="scroll-area scroll-area-height_90">
            <!-- default-expand-all -->
            <el-tree
            key="tree-1"
              v-if="roots && roots.length"
              :data="roots"
              :default-expanded-keys="[
                'TCT',
                'phongBanChucNangVaDonViTrucThuoc',
                'phongBanChucNang',
                'donViTrucThuoc',
              ]"
              :filter-node-method="filterTree"
              :default-expand-all="roots && roots[0] && roots[0].id !== 'TCT'"
              node-key="id"
              ref="departmentTree"
              class="filter-tree"
              :expand-on-click-node="false"
              v-loading="isLoading"
            >
              <div
                class="custom-tree-node flex-row flex__between width__100"
                slot-scope="{ node, data }"
              >
                <div class="field-1">
                  <span>
                    <el-checkbox
                      v-model="data.checked"
                      @change="checkedChangeEvent(data)"
                    ></el-checkbox>
                    <span
                      v-if="
                        data.nodeType ===
                        DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                      "
                    >
                      &nbsp;
                      <span class="font-weight__bold">
                        {{ data.userDeptRole.fullName }}
                      </span>
                      <span class="font-size__small font-italic">
                        ({{ data.userDeptRole.positionName }})
                      </span>
                    </span>
                    <span v-else>&nbsp;{{ getNodeLabel(data) }}</span>
                  </span>
                </div>
              </div>
            </el-tree>
            <el-tree key="tree-2" :data="roots" v-else v-loading="isLoading"></el-tree>
          </VuePerfectScrollbar>
        </el-col>
        <el-col :span="12" class="display-list__selected">
          <!-- chuyen xu ly -->
          <div
            :class="['list-selected', isLanhDao ? 'withAutoAssignTask' : '']"
          >
            <!-- title -->
            <div class="header">
              <div class="flex-row flex__between">
                <h5 class="title margin-0">Danh sách chuyển xử lý</h5>
                <div class="list-checkbox flex-row flex__right margin-right-10">
                  <h5
                    class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                  >
                    <span class="margin-bottom-5">Chủ trì</span>
                    <span>
                      <el-radio
                        v-model="processType"
                        :label="PROCESS_TYPE.CHUTRI"
                        @change="checkAllProcessType"
                        class="radio_chuyenXuLy"
                      ></el-radio>
                    </span>
                  </h5>
                  <h5
                    class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                  >
                    <span class="margin-bottom-5">Phối hợp</span>
                    <span>
                      <el-radio
                        v-model="processType"
                        :label="PROCESS_TYPE.PHOIHOP"
                        @change="checkAllProcessType"
                        class="radio_chuyenXuLy"
                      >
                      </el-radio>
                    </span>
                  </h5>
                  <h5
                    class="margin-0 item flex-col flex__center radio_chuyenXuLy"
                  >
                    <span class="margin-bottom-5">Nhận để biết</span>
                    <span>
                      <el-radio
                        v-model="processType"
                        :label="PROCESS_TYPE.NHANDEBIET"
                        @change="checkAllProcessType"
                        class="radio_chuyenXuLy"
                      >
                      </el-radio>
                    </span>
                  </h5>
                </div>
              </div>
            </div>
            <!-- end_title -->
            <div class="body">
              <div class="list-filter">
                <VuePerfectScrollbar
                  class="scroll-list-user"
                  :settings="perfectScrollbarSetting"
                >
                  <div
                    v-for="(item, index) in selectedHandlersData"
                    :key="index"
                    class="selected-user flex-row flex__between"
                  >
                    <div class="title flex-row flex__left">
                      <div class="clickable margin-right-10">
                        {{ index + 1 }}
                      </div>
                      <div
                        class="flex-row flex__left"
                        v-if="
                          item.data.nodeType ===
                          DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
                        "
                      >
                        <div class="avt">
                          <div
                            class="
                              avatar-fake
                              font-size__small
                              margin-right-10
                              flex-row flex__center
                            "
                          >
                            <span>{{
                              item.data.userDeptRole.fullName
                                | buildShortNameFilter
                            }}</span>
                          </div>
                        </div>
                        <div class="info">
                          <p class="people__name">
                            {{ item.data.userDeptRole.fullName }}
                          </p>
                          <p class="people__position margin-0">
                            {{ item.data.userDeptRole.positionName }} -
                            {{ item.data.userDeptRole.deptName }}
                          </p>
                        </div>
                      </div>
                      <div
                        class="flex-row flex__left"
                        v-else-if="
                          item.data.nodeType === DEPARTMENT_TREE.NODE_TYPE.DEPT
                        "
                      >
                        <div class="avt"></div>
                        <div class="info">
                          <p class="people__name">
                            {{ item.data.department.deptName }}
                          </p>
                          <p class="people__position margin-0">
                            ({{ item.data.department.identityCode }})
                          </p>
                        </div>
                      </div>
                    </div>
                    <div
                      class="list-checkbox flex-row flex__right margin-right-10"
                    >
                      <template>
                        <el-radio
                          class="item txt-center"
                          v-model="item.processType"
                          :label="PROCESS_TYPE.CHUTRI"
                          @change="refreshProcessType()"
                          >&nbsp;
                        </el-radio>
                        <el-radio
                          class="item txt-center"
                          v-model="item.processType"
                          :label="PROCESS_TYPE.PHOIHOP"
                          @change="refreshProcessType()"
                        >
                          &nbsp;
                        </el-radio>
                        <el-radio
                          class="item txt-center"
                          v-model="item.processType"
                          :label="PROCESS_TYPE.NHANDEBIET"
                          @change="refreshProcessType()"
                        >
                          &nbsp;
                        </el-radio>
                      </template>

                      <i
                        class="
                          icon-close
                          color__red
                          clickable
                          font-size__medium
                          el-icon-circle-close
                        "
                        @click="removeFromSelectedHandlersData(item)"
                      ></i>
                    </div>
                  </div>
                </VuePerfectScrollbar>
              </div>
            </div>
          </div>
          <el-form label-position="top">
            <el-form-item label="Ý kiến/đề xuất">
              <el-input
                type="textarea"
                resize="none"
                :autosize="{ minRows: 2, maxRows: 2 }"
                placeholder="_"
                v-model="form.note"
              />
            </el-form-item>
          </el-form>
          <el-form label-position="left" label-width="60px">
            <el-row :gutter="24" class="">
              <el-col :span="7" class="margin-bottom-5" style="margin-top: 5px">
                <el-tooltip
                  v-if="isLanhDao"
                  content="Khi chuyển văn bản, công việc sẽ được tạo tự động cho đơn vị/cá nhân chủ trì"
                  placement="top"
                >
                  <el-checkbox
                    class="margin-top-5"
                    v-model="form.isAutoAssignTask"
                    >Tự động giao việc
                  </el-checkbox>
                </el-tooltip>
              </el-col>
              <el-col
                v-if="form.isAutoAssignTask"
                :span="8"
                class="margin-bottom-5"
              >
                <el-form-item prop="startDate" label="Bắt đầu">
                  <el-date-picker
                    v-model="form.startDate"
                    align="top"
                    format="dd/MM/yyyy"
                    size="medium"
                    @change="updateManday('startDate')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
              <el-col
                v-if="form.isAutoAssignTask"
                :span="8"
                class="margin-bottom-5"
              >
                <el-form-item prop="deadline" label="Kết thúc">
                  <el-date-picker
                    v-model="form.deadline"
                    align="top"
                    format="dd/MM/yyyy"
                    size="medium"
                    @change="updateManday('deadline')"
                  >
                  </el-date-picker>
                </el-form-item>
              </el-col>
            </el-row>
          </el-form>
        </el-col>
      </el-row>
    </template>
    <template #footer>
      <div class="flex-row flex__right form-button__action">
        <el-button
          class="dialogBtnPrimary"
          @click="submit"
          :disabled="isProcessing"
        >
          <i
            :class="[
              !isProcessing
                ? 'fas fa-check-circle font-size__small'
                : 'el-icon-loading',
            ]"
          ></i>
          &nbsp;Xác nhận
        </el-button>
        <el-button
          class="btn__cancel btn-none__border"
          @click="$emit('closeDialog')"
        >
          <i class="fal fa-times"></i>
          &nbsp;Hủy
        </el-button>
      </div>
    </template>
  </dialogTemplate>
</template>
<script>
import VuePerfectScrollbar from "vue-perfect-scrollbar";
import buildShortNameFilter from "../../../filters/buildShortNameFilter.js";
import constants from "../../../constants";
import nextStepInfoViewService from "../../../services/nextStepInfoViewService";
import h from "../../../services/h";
import HashtagCommon from "./chuyenXuLy-hashtag";
import cxlVbdenCommonMixin from "../../../mixins/cxlVbdenCommonMixin";

export default {
  name: "cxl-vbden-common",
  mixins: [cxlVbdenCommonMixin],
  filters: { buildShortNameFilter },
  props: [
    "flowId",
    "stepId",
    "isOpen",
    "quote",
    "incomingProcessId",
    "nextVbIncomingProcess",
    "selectedHandlers",
    "note",
    "isProcessing",
    "defaultProcessType",
  ],
  components: {
    HashtagCommon,
    dialogTemplate: () => import("../../common/custom-dialog.vue"),
    chuyenXuLyHashtag: () => import("./chuyenXuLy-hashtag.vue"),
    VuePerfectScrollbar,
  },

  data() {
    return {
      form: {
        manday: 1,
      },
    };
  },

  computed: {
    userDeptRole() {
      return this.$store.getters.userDeptRole;
    },
    isLanhDao() {
      return (
        this.userDeptRole &&
        this.userDeptRole.roleCode === constants.ROLE.CODE.LANH_DAO
      );
    },
  },

  methods: {
    getBusinessDatesCount(startDate, endDate) {
      var count = 0;
      var curDate = new Date(startDate);
      while (curDate.getTime() <= endDate.getTime()) {
        let dayOfWeek = curDate.getDay();
        if (dayOfWeek == 6 || dayOfWeek == 0) count++;
        curDate.setDate(curDate.getDate() + 1);
      }
      return count;
    },
    updateManday(key) {
      let startTime = this.form.startDate
        ? this.form.startDate.getTime()
        : null;
      let endTime = this.form.deadline ? this.form.deadline.getTime() : null;
      if (startTime && endTime && endTime >= startTime) {
        this.form.manday =
          (endTime - startTime) / 86400000 +
          1 -
          this.getBusinessDatesCount(this.form.startDate, this.form.deadline);
      }
      if (endTime && startTime && endTime < startTime) {
        if (key === "deadline") {
          let deadlineConstrains = {
            required: true,
            message: "Ngày kết thúc phải không được nhỏ hơn ngày bắt đầu",
            trigger: "blur",
          };
          this.form.deadline = null;
          this.rules.deadline = [deadlineConstrains];
        }
        if (key === "startDate") {
          let startDateConstrains = {
            required: true,
            message: "Ngày bắt đầu phải không được lớn hơn ngày kết thúc",
            trigger: "blur",
          };
          this.form.startDate = null;
          this.rules.startDate = [startDateConstrains];
        }
      }
    },
    checkedChangeEvent(data) {
      // Check xem đã có người chủ trì chưa
      let checkkeyMenber =
        this.selectedHandlersData.filter(
          (item) => item.processType === constants.PROCESS_TYPE.CHUTRI
        ).length === 0;
      this.checkedChange(
        data,
        data.isHandlerNode && checkkeyMenber
          ? constants.PROCESS_TYPE.CHUTRI
          : this.defaultProcessType || constants.PROCESS_TYPE.PHOIHOP
      );
    },

    initForm() {
      this.form.note = this.note;
      return this.loadNextStepsInfo(this.flowId, this.stepId)
        .then((nextSteps) => {
          this.nextSteps = nextSteps;
          return this.loadHandlers(this.stepId, nextSteps);
        })
        .then((results) => {
          let userDeptRolesSet = results[0];
          let departments = results[1];
          this.userDeptRoleHandlers = userDeptRolesSet;
          this.departmentHandlers = departments;
          this.filterAllAlreadyForwardedHandlers();
          this.buildNodes().then(() => {
            h.each(this.roots, (root) =>
              this.markCheckedForSelectedHandlers(root)
            );
            this.refreshProcessType();
            this.isLoading = false;
          });
        });
    },

    searchTree() {
      this.$refs.departmentTree.filter(this.search);
    },

    loadNextStepsInfo(flowId, stepId) {
      return nextStepInfoViewService
        .nextSteps(flowId, stepId)
        .then((response) => response.data);
    },

    markCheckedForSelectedHandlers(data) {
      h.each(data.children, (child) =>
        this.markCheckedForSelectedHandlers(child)
      );
      if (data.isHandlerNode) {
        let nodeType = data.nodeType;
        let selectedHandler;
        switch (nodeType) {
          case constants.DEPARTMENT_TREE.NODE_TYPE.DEPT:
            let department = data.department;
            selectedHandler = h.find(
              this.selectedHandlers,
              (item) =>
                item.stepType === constants.STEP.STEP_TYPE.DONVI &&
                department.id === item.department.id
            );
            break;
          case constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE:
            let userDeptRole = data.userDeptRole;
            selectedHandler = h.find(
              this.selectedHandlers,
              (item) =>
                item.stepType === constants.STEP.STEP_TYPE.CANHAN &&
                userDeptRole.id === item.userDeptRole.id
            );
            break;
          default:
            break;
        }
        if (selectedHandler) {
          this.$set(data, "checked", true);
          this.addOrRemoveToSelectedHandlers(data, selectedHandler.processType);
        }
      } else {
        let isAllChildNodesChecked = !h.exists(
          data.children,
          (child) => !child.checked
        );
        this.$set(data, "checked", isAllChildNodesChecked);
      }
    },

    filterAllAlreadyForwardedHandlers() {
      this.userDeptRoleHandlers = h.findAll(
        this.userDeptRoleHandlers,
        (userDeptRole) =>
          h.indexOf(
            this.nextVbIncomingProcess,
            (process) =>
              process.stepType === constants.STEP.STEP_TYPE.CANHAN &&
              (process.receiverUserDeptRoleId === userDeptRole.id ||
                (process.receiverId === userDeptRole.userId &&
                  process.deptReceiverId === userDeptRole.deptId &&
                  process.roleReceiverId === userDeptRole.roleId))
          ) === -1
      );

      this.departmentHandlers = h.findAll(
        this.departmentHandlers,
        (department) =>
          h.indexOf(
            this.nextVbIncomingProcess,
            (process) =>
              process.stepType === constants.STEP.STEP_TYPE.DONVI &&
              process.deptReceiverId === department.id
          ) === -1
      );
    },

    submit() {
      if (!this.validate()) return;
      let handlersData = [];
      this.selectedHandlersData
        .filter(
          (item) =>
            item.data.nodeType ===
            constants.DEPARTMENT_TREE.NODE_TYPE.USER_DEPT_ROLE
        )
        .forEach((item) => {
          handlersData.push({
            userDeptRole: item.data.userDeptRole,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.CANHAN,
          });
        });

      this.selectedHandlersData
        .filter(
          (item) =>
            item.data.nodeType === constants.DEPARTMENT_TREE.NODE_TYPE.DEPT
        )
        .map((item) => {
          handlersData.push({
            department: item.data.department,
            processType: item.processType,
            stepId: this.findStepIdForHandler(
              item.data,
              this.stepId,
              this.nextSteps
            ),
            stepType: constants.STEP.STEP_TYPE.DONVI,
          });
        });

      this.$emit("submit", {
        handlersData: handlersData,
        note: this.form.note,
        isAutoAssignTask: this.form.isAutoAssignTask,
        startDate: this.form.startDate,
        deadline: this.form.deadline,
        manday: this.form.manday,
      });
    },
  },
};
</script>
<style scoped>
.title {
  width: 100%;
}

.list-checkbox {
  position: relative;
  margin-right: 10px;
}

.scroll-list-user {
  height: auto;
  width: 100%;
  max-width: 100%;
  max-height: 100%;
  margin: auto;
}

.list-checkbox .item {
  width: 90px;
  text-align: center;
  margin: 0;
}

.icon-close {
  position: absolute;
  right: -5px;
  font-size: 18px;
}

.dialog-body .display-list__selected .list-selected .header > div {
  width: 100%;
}

.dialog-body .display-list__selected .list-selected .body {
  padding: 0;
}

.dialogTransferHandling .dialog-body .list-collapse__transfer {
  display: flex;
  flex-direction: column;
}

.dialogTransferHandling .dialog-body .scroll-area-height_90 {
  height: 100%;
  margin-bottom: 0;
  margin-right: -13px;
}

.dialog-body .display-list__selected {
  height: 440px;
}

.dialogTransferHandling .dialog-body .display-list__selected .list-selected {
  height: calc(100% - 121px);
}

.dialogTransferHandling
  .dialog-body
  .display-list__selected
  .list-selected.withAutoAssignTask {
  height: calc(100% - 170px) !important;
}

.dialog-body .display-list__selected .list-selected .header {
  padding-left: 10px;
  padding-right: 10px;
}

.dialog-body .display-list__selected .list-selected .body .list-filter {
  height: 100%;
}

.dialogTransferHandling .dialog-body .list-collapse__transfer {
  height: 440px;
}

/*.dialogTransferHandling .dialog-body .list-collapse__transfer {*/
/*  height: 405px;*/
/*}*/

/*.pScrollDialog {*/
/*  height: 405px!important;*/
/*}*/
.el-date-editor.el-input,
.el-date-editor.el-input__inner {
  width: 140px;
}

.dialogTransferHandling .withAutoAssignTask {
  word-break: break-word;
}
</style>



// WEBPACK FOOTER //
// src/views/doc-in/components/cxl-vbden-common.vue